module.exports = __webpack_public_path__ + "img/background.c8ea5b52.jpg";